import { useQuery } from "@apollo/client";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  Typography,
  LinearProgress,
  withStyles,
} from "@material-ui/core";
import {Button} from 'react-bootstrap'
import {useStyles} from './Style'
import { useHistory } from "react-router-dom";
import { GET_PROJECT_PLANNER } from "../../../graphql/queries";
import { connect } from "react-redux";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#007bff",
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const ProjectPlanner = ({currentUser}) => {
  const classes = useStyles();
  const history = useHistory();
  const { data, loading, error } = useQuery(GET_PROJECT_PLANNER, {
    pollInterval: 1000,
  });
  if (loading) return <LinearProgress />;

  if (error) return <div>Error...</div>;

  console.log(currentUser)

  // const sortByID = data.findAllProjectPlanner.sort(({id: previousID}, {id: currentID}) => previousID - currentID)

  const getAllProjectPlanner = data.findAllProjectPlanner
    .slice()
    .filter((item) => item.created_by.id == currentUser)
    .sort(({ id: previousID }, { id: currentID }) => previousID - currentID)
    .map(({ id, title, description, status }, key) => {
      return (
        <TableBody key={key}>
          <TableCell className="text-center">{id}</TableCell>
          <TableCell className="text-center">{title}</TableCell>
          <TableCell className="text-center">{description}</TableCell>
          <TableCell
            className={`${
              status === "submit"
                ? "bg-primary text-white"
                : status === "approve"
                ? "bg-success text-white"
                : status === "return"
                ? "bg-warning text-white"
                : status === "complete"
                ? "bg-info text-white"
                : "bg-danger text-white"
            } text-center text-capitalize`}
          >
            {status}
          </TableCell>
          <TableCell className="d-flex justify-content-center align-content-center">
            <Button
              variant={`${status === 'approve' || status === "return" ? "outline-secondary" : "outline-primary"}`}
              className={`${status === "reject" || status === "complete" ? "d-none" : ""}`}
              onClick={() =>
                history.push({
                  pathname: `/dashboard/planner/project-list/${id}`,
                })
              }
            >
              {status === "approve" || status === "return" 
                ? "Update Task"
                : "Add New Task"}
            </Button>
          </TableCell>
        </TableBody>
      );
    });

    
  return (
    <Paper className={`${classes.paper} p-5`}>
      <Typography variant="h6" component="h3">
        Recent Project
      </Typography>
      <Table className={classes.table}>
        <TableHead>
          <StyledTableCell className="text-center">ID</StyledTableCell>
          <StyledTableCell className="text-center">Project Name</StyledTableCell>
          <StyledTableCell className="text-center">Description</StyledTableCell>
          <StyledTableCell className="text-center">Status</StyledTableCell>
          <StyledTableCell className="text-center">Action</StyledTableCell>
        </TableHead>
        {getAllProjectPlanner}
      </Table>
    </Paper>
  );
};

const mapStateToProps = state => {
  return {
    currentUser: state.planner.createNewProject.created_by,
  };
}



export default connect(mapStateToProps, null)(ProjectPlanner);
